module.exports = __webpack_public_path__ + "static/media/texto_1.d89c54ce.png";